import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import {
	ISSUE_DISBURSEMENT_MODAL__BODY_TEXT_TITLE,
	ISSUE_DISBURSEMENT_MODAL__CANCEL,
	ISSUE_DISBURSEMENT_MODAL__SUBMIT,
	ISSUE_DISBURSEMENT_MODAL__TITLE,
} from '../data/constants';

interface IssueDisbursementModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const IssueDisbursementModal = (props: IssueDisbursementModalProps) => {
	const { open, onClose, onConfirm } = props;
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{ISSUE_DISBURSEMENT_MODAL__TITLE}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{ISSUE_DISBURSEMENT_MODAL__BODY_TEXT_TITLE}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color='neutralButton'>
					{ISSUE_DISBURSEMENT_MODAL__CANCEL}
				</Button>
				<Button onClick={onConfirm} variant='contained'>
					{ISSUE_DISBURSEMENT_MODAL__SUBMIT}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default IssueDisbursementModal;
